<div class="menu" [ngClass]="{ 'menu-open': open }" (transitionend)="animationEnd($event)" (mouseenter)="showMenu()" (mouseleave)="hideMenu()">
    <div class="logo-box flex justify-content-between">
          <img *ngIf="open" class="logo-reativo" src="/assets/logo-reative.svg" alt="logo">
          <img  *ngIf="!open"class="logo" src="/assets/logo-icon.svg" alt="logo">
          <div *ngIf="open" class="btn-content-menu">
              <p-button (onClick)="closeMenu()" class="btn-menu" icon="pi pi-times" severity="secondary"></p-button>
          </div>
    </div>
    <!--(node === selectedNode)-->
    <ng-template #nodeTemplate let-nodes="nodes" let-tree="tree">
        <ng-container *ngFor="let node of nodes">
          <div @onOff class="menu-node" role="button"  [ngClass]=" { 'menu-node-tree' : tree }">

            <div class="menu-node-content"
                (click)="toggleVisible(node)"
                (click)="selectNode(node)"
                [ngClass]="{
                'menu-node-button-show': open,
                'menu-node-name-selected': tree == false ? getUrlSelected(node) : false,
                'menu-node-button-minus': expand[node.index]
                }">
                <div
                class="menu-node-name flex align-items-center"
                >
                    <div class="menu-node-icon" *ngIf="node.icon && node.icon.length" [ngStyle]="{'-webkit-mask': 'url(' + node.icon + ')'}"></div>
                    <ng-container *ngIf="open">  <div  [style.min-width]="'12rem'">{{ node.title }}</div> </ng-container>
                </div>
                <div class="menu-node-arrow" *ngIf="open && (node.submenu && node.submenu.length)"></div>
            </div>
            <ng-container
            *ngIf="open && (node.submenu && node.submenu.length && expand[node.index])"
            >
              <ng-template
                [ngTemplateOutlet]="nodeTemplate"
                [ngTemplateOutletContext]="{ nodes: node.submenu, tree: true }"
              >
              </ng-template>
            </ng-container>
          </div>
        </ng-container>
      </ng-template>

      <ng-template
        [ngTemplateOutlet]="nodeTemplate"
        [ngTemplateOutletContext]="{ nodes: menu, tree: false }"
      >
      </ng-template>

</div>
